import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { appointableQueryKeys } from "./appointableQueryKeys";

export async function appointableListQueryFn({
  api,
  filter,
}: {
  api: ApiType;
  filter: Parameters<ApiType["appointableApi"]["find"]>[0];
}) {
  return (await api.appointableApi.find(filter)).data;
}

export function useAppointableList({
  api,
  opts,
}: {
  api: ApiType;
  opts: Parameters<ApiType["appointableApi"]["find"]>[0];
}) {
  return useQuery({
    queryKey: appointableQueryKeys.list(opts),
    queryFn: () => appointableListQueryFn({ api, filter: opts }),
  });
}
